import type { FC } from "react";

import {
  HORIZONTAL_RULE_BASE_CLASS,
  HORIZONTAL_RULE_COLOR_CLASS_MAP,
  HORIZONTAL_RULE_DEFAULTS,
  type THorizontalRuleProps,
} from "@/ui/components/layout/HorizontalRule/HorizontalRule.config";
import { cn } from "@/ui/lib/utils";

export const HorizontalRule: FC<THorizontalRuleProps> = (
  {
    className,
    color = HORIZONTAL_RULE_DEFAULTS.color,
    ...props
  },
) => (
  <hr
    {...props}
    data-component="HorizontalRule"
    className={cn(
      HORIZONTAL_RULE_BASE_CLASS,
      HORIZONTAL_RULE_COLOR_CLASS_MAP[color],
      className,
    )}
  />
);

HorizontalRule.displayName = "HorizontalRule";
